import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class IconsService {
    private iconCache: { [key: string]: BehaviorSubject<string> } = {};

    constructor(private http: HttpClient) {}

    loadIcon(iconName: string): Observable<string> {
        if (this.iconCache[iconName]) {
            //The icon is already loaded, we return it from BehaviorSubject
            return this.iconCache[iconName].asObservable();
        } else {
            // Create a new BehaviorSubject for this icon
            const iconSubject = new BehaviorSubject<string>('');
            this.iconCache[iconName] = iconSubject;

            const iconUrl = `assets/images/iconsax/${iconName}.svg`;

            // Load the icon and update the BehaviorSubject with the result
            this.http
                .get(iconUrl, { responseType: 'text' })
                .pipe(
                    map((svgContent) => {
                        // The icon was downloaded successfully, we update the BehaviorSubject with the content
                        iconSubject.next(svgContent);
                        return svgContent;
                    }),
                    catchError((error) => {
                        // Handle the icon loading error and update the BehaviorSubject
                        console.error(`Iconsax download error ${iconName}`, error);
                        iconSubject.next('error');
                        return of('');
                    })
                )
                .subscribe();

            // Повертаємо BehaviorSubject як Observable
            return iconSubject.asObservable();
        }
    }
}
